<ion-row
  class="payment-dashboard-row touch"
  (click)="goToAllInvoices()"
  [ngClass]="{
    green: customerMetrics.creditStatus === CreditStatus.active,
    yellow: customerMetrics.creditStatus === CreditStatus.softHold,
    red: customerMetrics.creditStatus === CreditStatus.onHold,
  }"
>
  <ion-col size="12">
    <ion-row data-cy="ar-aging-row-customer-information">
      <strong data-cy="ar-aging-row-customer-name">
        {{ customerMetrics.customerName | titlecase }}
      </strong>
      <p data-cy="ar-aging-row-customer-number">
        #{{ customerMetrics.customerNumber }}
      </p>
    </ion-row>

    <ion-row class="subtitle">
      <p class="current-percentage" data-cy="ar-aging-row-current-percentage">
        {{ 'i18n.payments.paymentDashboard.tableHeaders.current' | translate }}:
        {{ customerMetrics.currentPercentage }}%
      </p>
      <p class="term" data-cy="ar-aging-row-term">
        {{ customerMetrics.term }}
      </p>
    </ion-row>
  </ion-col>

  <ion-col size="5.5">
    <p data-cy="ar-aging-row-one-seven-days">
      {{ 'i18n.payments.paymentDashboard.tableHeaders.oneSeven' | translate }}:
      {{ customerMetrics.oneSevenDays | currency }}
    </p>
    <p
      data-cy="ar-aging-row-eight-fifteen-days
    "
    >
      {{
        'i18n.payments.paymentDashboard.tableHeaders.eightFifteen' | translate
      }}:
      {{ customerMetrics.eightFifteenDays | currency }}
    </p>
  </ion-col>

  <ion-col size="5.5">
    <p data-cy="ar-aging-row-sixteen-thirty-days">
      {{
        'i18n.payments.paymentDashboard.tableHeaders.sixteenThirty' | translate
      }}:
      {{ customerMetrics.sixteenThirtyDays | currency }}
    </p>
    <p
      data-cy="ar-aging-row-thirty-plus
    "
    >
      {{
        'i18n.payments.paymentDashboard.tableHeaders.thirtyPlus' | translate
      }}:
      {{ customerMetrics.thirtyPlus | currency }}
    </p>
  </ion-col>

  <ion-col size="1" data-cy="chevron-next">
    <ion-icon name="chevron-forward-outline"></ion-icon>
  </ion-col>
</ion-row>
